module.exports = __webpack_public_path__ + "media/Ringtone_1.c1c735c6.mp3";